<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">应急物资动态管理系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          应急物资动态管理系统围绕应急物资“采、储、调、用、补”全生命周期，构建统一物资目录、多仓协同、动态监测、快速调拨与全程追溯的管理体系，支撑应急管理部门在常态下管得好、在急时调得动、用得上，提升突发事件应急保障能力。
        </p>
        <p class="content-paragraph">
          系统通过条码 / RFID 等技术实现物资出入库、盘点、移库的精细化作业，建立库存阈值预警与效期临期提醒机制，自动生成补货建议；在应急响应状态下支持一键调拨、运单跟踪、发放签收与回收处置，并结合 GIS 地图实现物资分布可视化与指挥调度，确保应急物资保障精准高效、账实相符。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">物资台账与仓储</h3>
            <ul class="capability-list"><li>统一物资目录</li><li>供应商管理</li><li>批次与效期</li><li>多仓管理</li><li>条码与 RFID</li><li>出入库作业</li><li>库存盘点</li><li>移库调仓</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">监测预警与补货</h3>
            <ul class="capability-list"><li>库存阈值预警</li><li>效期临期提醒</li><li>缺货预测</li><li>智能补货建议</li><li>物资状态监控</li><li>预警推送</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">调度指挥与追溯</h3>
            <ul class="capability-list"><li>应急调拨</li><li>运单跟踪</li><li>发放签收</li><li>回收处置</li><li>GIS 分布图</li><li>全程追溯</li><li>统计报表</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yj-warehouse.svg"
              alt="海南华德科技有限公司 应急物资动态管理系统 - 物资台账 · 多仓精细化管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>物资台账 · 多仓精细化管理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yj-alert.svg"
              alt="海南华德科技有限公司 应急物资动态管理系统 - 预警中心 · 库存监测与智能补货"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>预警中心 · 库存监测与智能补货
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yj-dispatch.svg"
              alt="海南华德科技有限公司 应急物资动态管理系统 - 应急调拨 · 一键调度与运单跟踪"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>应急调拨 · 一键调度与运单跟踪
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/yj-mobile.svg"
              alt="海南华德科技有限公司 应急物资动态管理系统 - 移动端 · 扫码出入库与现场签收"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>移动端 · 扫码出入库与现场签收
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs7.vue